import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCg = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 3 2", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { id: "green_area", width: 3, height: 2, fill: "#009543" }), /* @__PURE__ */ React.createElement("path", { id: "yellow_area", d: "M 0 2 L 2 0 h 1 v 2 z", fill: "#FBDE4A" }), /* @__PURE__ */ React.createElement("path", { id: "red_area", d: "M 3 0 v 2 h -2 z", fill: "#DC241F" }));
const ForwardRef = forwardRef(SvgCg);
const Memo = memo(ForwardRef);
export default Memo;
